import styles from "./OfferBox.module.scss"

interface Props {
  title: string
  offerName: string
  subtitleComponent: JSX.Element
  bottomRightSubtitle: string
}

const OfferBox = (props: Props) => {
  return (
    <div className={styles.price_box}>
      <div className={styles.header}>
        <label className={styles.header_title}>{props.title}</label>
      </div>

      <div className={styles.content}>
        <div className={styles.yearly}>
          <label className={styles.yearly_title}>{props.offerName}</label>
          <label className={styles.yearly_subtitle}>
            {props.subtitleComponent}
          </label>
        </div>
        <div className={styles.per_month_container}>
          <label className={styles.yearly_subtitle}>
            {props.bottomRightSubtitle}
          </label>
        </div>
      </div>
    </div>
  )
}

export default OfferBox
